import React from 'react';
import { observer } from 'mobx-react';
import { NikoNewPatientTemplateCreateTemplate } from 'themes/application/niko-patient/components';

@observer
class NikoNewPatientTemplateCreate extends React.Component {
    render() {
        return <NikoNewPatientTemplateCreateTemplate {...this.props} />
    }
}

export default NikoNewPatientTemplateCreate;
